import Repository from "./Repository";

const CREATE_COUPON = "add";
const UPDATE_COUPON = "update";
const GET_COUPON = "get";
const DELETE_COUPON = "delete";
const SUBMIT_COUPON = "submitCoupon";

export default {
  create_coupon(payload) {
    return Repository.post(transformRoute(CREATE_COUPON), payload);
  },
  update_coupon(payload) {
    return Repository.post(transformRoute(UPDATE_COUPON), payload);
  },
  get_coupon(payload) {
    return Repository.get(transformRoute(GET_COUPON), { params: payload });
  },
  delete_coupon(payload) {
    return Repository.post(transformRoute(DELETE_COUPON), payload);
  },
  submit_coupon(payload) {
    return Repository.post(transformRoute(SUBMIT_COUPON), payload);
  },
};

const transformRoute = (route) => {
  return `coupon/${route}`;
};
